import { Box, Stack, Typography } from '@montugroup/design-system';
import { styled } from '@mui/material';

const CardContainer = styled(Box)(({ theme }) => ({
  border: `1px solid ${theme.palette.action.disabled}`,
  borderRadius: theme.shape.borderRadius,
  backgroundColor: theme.palette.grey[200],
  padding: theme.spacing(3),
}));

export const NoClickAndCollectCard = () => {
  return (
    <CardContainer>
      <Stack spacing={2}>
        <Stack direction="row" spacing={1} alignItems="center" justifyContent="space-between">
          <Typography fontWeight={600}>Click & Collect</Typography>
          <Typography fontWeight={600}>Unavailable</Typography>
        </Stack>
        <Typography variant="body2">
          Unfortunately, there are no pharmacies with Click and Collect availability nearby the address entered.
        </Typography>

        <Typography variant="body2">
          You can always have your medication(s) delivered or update your address.
        </Typography>
      </Stack>
    </CardContainer>
  );
};
